module.exports = __webpack_public_path__ + "static/media/ni.77b6052c.webp";